export const clinicKeys = {
  base: () => ["clinic"],
  clinic: () => [...clinicKeys.base(), "clinic"],
  apiIntegration: () => [...clinicKeys.base(), "apiIntegration"],
  globalPatientSettings: () => [...clinicKeys.base(), "globalPatientSettings"],
  billingProfile: () => [...clinicKeys.base(), "billingProfile"],
  dietitians: () => [...clinicKeys.base(), "dietitians"],
  dietitian: (id: number) => [...clinicKeys.base(), "dietitian", id],
  featureUsage: (featureId: number) => [
    ...clinicKeys.base(),
    "featureUsage",
    featureId,
  ],
  usagePatients: () => [...clinicKeys.base(), "usagePatients"],
  usageDietitians: () => [...clinicKeys.base(), "usageDietitians"],
  activities: (params: string) => [...clinicKeys.base(), "activities", params],
  activitiesPeriods: () => [...clinicKeys.base(), "activitiesPeriods"],
};
